module.exports = __webpack_public_path__ + "static/media/learnMore.a2b04169.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Home/learnMore.svg
 ** module id = 632
 ** module chunks = 0
 **/